import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Table } from "reactstrap";
import PageLayout from "../PageLayout";
import { joinedAllJournalsApi, leaveJournalApi } from "src/network/api";

const JoinedJournalsList = () => {
  const [joinedJournals, setJoinedJournals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchJoinedJournals = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await joinedAllJournalsApi();
      if (response?.data?.status === 200) {
        setJoinedJournals(response.data.data || []);
      } else {
        setError(response?.data?.message || "Failed to fetch data.");
      }
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJoinedJournals();
  }, []);

  // Function to leave a journal
  const handleLeaveJournal = async (requestId) => {
    if (!requestId) {
      alert("Invalid request. Please try again.");
      return;
    }

    if (!window.confirm("Are you sure you want to leave this journal?")) return;

    try {
      const response = await leaveJournalApi(requestId);

      if (response?.data?.status === 200) {
        alert("Journal successfully removed.");
        setJoinedJournals((prevJournals) =>
          prevJournals.filter((journal) => journal.request_id !== requestId)
        );
      } else {
        throw new Error(response?.data?.message || "Failed to remove journal.");
      }
    } catch (error) {
      console.error("Error removing journal:", error);

      if (
        error?.response?.status === 400 &&
        error?.response?.data?.message === "Joined Link not found"
      ) {
        alert("This journal may have already been removed or does not exist.");
      } else {
        alert(error.message || "An unexpected error occurred.");
      }
    }
  };

  return (
    <PageLayout>
      <div className="table-container mt-2 mb-2" style={{ padding: "10px" }}>
        <Card className="shadow-lg">
          <CardHeader className="bg-primary">
            <h3 className="mb-0 text-center font-weight-bold text-white">
              All Journals List
            </h3>
          </CardHeader>
          <CardBody>
            {loading ? (
              <p className="text-center text-primary">Loading...</p>
            ) : error ? (
              <p className="text-center text-danger">{error}</p>
            ) : (
              <div style={{ overflowX: "auto", width: "100%" }}>
                <Table
                  bordered
                  hover
                  responsive
                  className="table-sm mb-0 text-center"
                >
                  <thead className="thead-light">
                    <tr>
                      <th>Journal ID</th>
                      <th>Request ID</th>
                      <th>Journal Name</th>
                      <th>E_ISSN</th>
                      <th>P_ISSN</th>
                      <th>Publisher Name</th>
                      <th>Research Area</th>
                      <th>Country</th>
                      <th>State</th>
                      <th>Publication Type</th>
                      <th>Website</th>
                      <th>Joining Date</th>
                      <th>Leave Journal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {joinedJournals.length > 0 ? (
                      joinedJournals.map((journal, index) => (
                        <tr key={index}>
                          <td>{journal.journal_id}</td>
                          <td>{journal.request_id}</td>
                          <td>{journal.journal_name}</td>
                          <td>{journal.eissn_no || "N/A"}</td>
                          <td>{journal.pissn_no || "N/A"}</td>
                          <td>{journal.publisher_name}</td>
                          <td>{journal.broad_research_area}</td>
                          <td>{journal.publisher_country_name}</td>
                          <td>{journal.publisher_state_name}</td>
                          <td>{journal.publication_type || "N/A"}</td>
                          <td>
                            {journal.website_link ? (
                              <a
                                href={journal.website_link}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Visit
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                          <td>{journal.created_at || "N/A"}</td>
                          <td>
                            <Button
                              className="mt-2 mb-2"
                              color="danger"
                              size="sm"
                              onClick={() =>
                                handleLeaveJournal(journal.request_id)
                              }
                            >
                              Leave
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={13} className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
    </PageLayout>
  );
};

export default JoinedJournalsList;
